import classNames from "classnames"
import styles from "../../../../styles/LandingPage/Patients.module.scss"
import { FC } from "react"

import { SectionProps } from "./SectionType"

const SectionEight: FC<SectionProps> = ({ children, backgroundColor }) => {
  return (
    <section
      style={{
        backgroundColor: backgroundColor,
      }}
      className={classNames(styles.sectionMedium, styles.sectionEight, styles.advisorSection)}
    >
      {children}
    </section>
  )
}

export default SectionEight
